import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { filter, map, take } from 'rxjs';

import { createContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { SeoSchemaService } from 'ish-core/services/seo-schema/seo-schema.service';
import { isServerConfigurationLoaded } from 'ish-core/store/core/server-config';
import { delayUntil, mapToPayload, whenTruthy } from 'ish-core/utils/operators';

import { setSchema } from './schema.actions';

@Injectable()
export class SchemaEffects {
  constructor(private seoSchemaService: SeoSchemaService, private actions$: Actions, private store: Store) {}

  getSchemaPagelet$ = createEffect(() =>
    this.seoSchemaService.schemaPagelet$.pipe(
      whenTruthy(),
      delayUntil(this.store.pipe(select(isServerConfigurationLoaded)).pipe(filter(isConfigLoaded => isConfigLoaded))),
      take(1),
      map(pagelet => setSchema({ pagelet }))
    )
  );

  setSchema$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setSchema),
        mapToPayload(),
        map(({ pagelet }) => {
          const pageletView = createContentPageletView(pagelet);
          if (pageletView.hasParam('Schema')) {
            this.seoSchemaService.setContentPageSchemaData(pageletView.stringParam('Schema', undefined));
          }
        })
      ),
    { dispatch: false }
  );
}
